module.exports = __webpack_public_path__ + "img/facebook.85c83eb2.svg";